<template>
  <div>
    <el-switch
      v-model="checked"
      :active-text="activeText"
      :active-color="uiVariable.color.purple"
      :inactive-color="uiVariable.color.purple2"
      :inactive-text="inactiveText"
    >
    </el-switch>
  </div>
</template>

<script>
import K2Row from '../k2Row/k2Row'
import uiVariable from '../../config/uiVariable'
export default {
  name: 'K2Switch',
  components: { K2Row },
  props: ['onchange', 'item', 'selected', 'state', 'withoutLabel', 'activeText', 'inactiveText'],
  data() {
    return {
      selectedGroup: this.selected,
      checked: null,
      uiVariable: uiVariable,
    }
  },
  watch: {
    selectedGroup: function (value) {
      this.$emit('onchange', value)
    },
    selected: function () {
      this.selectedGroup = this.selected
    },
    label: function (value) {
      this.$emit('onchange', value)
    },
    checked: function (value) {
      this.$emit('onchange', this.item, value)
    },
    state: function (value) {
      this.checked = value
    },
  },
}
</script>
